import { parseLegacyJdReference } from "../../customization";

/** 兼容旧系统把 JiDiaoNo 放在手机路由项目号里，例如 JD202606230001_1。 */
export function parseLegacyJiDiaoRouteProject(
  value: string,
): { projectId: string; legacyJiDiaoNo?: string } | null {
  const legacyReference = parseLegacyJdReference(value);
  if (!legacyReference) {
    return null;
  }
  return {
    projectId: legacyReference.batchNo,
    legacyJiDiaoNo: legacyReference.referenceKey,
  };
}

/** 读取旧系统版本号查询参数，保留 JiDiaoNo 为主入口并兼容常见别名。 */
export function readLegacyJiDiaoNoFromSearch(searchParams: URLSearchParams): string | undefined {
  const candidateKeys = ["JiDiaoNo", "JD_No", "JD", "orderVersionKey", "version"];
  for (const key of candidateKeys) {
    const value = searchParams.get(key)?.trim();
    const legacyReference = parseLegacyJdReference(value);
    if (legacyReference) {
      return legacyReference.referenceKey;
    }
  }
  return undefined;
}
